// src/hooks/useTasks.js
import { useState } from 'react';

export function useTasks() {
  const [tasks, setTasks] = useState([]);

  const [newTask, setNewTask] = useState('');
  const [taskPriority, setTaskPriority] = useState('Normal');
  const [estimatedPomodoros, setEstimatedPomodoros] = useState(1);
  const [taskCategory, setTaskCategory] = useState('');

  function addTask() {
    const trimmedTask = newTask.trim();
    if (!trimmedTask) return;

    const pomodoros = Math.max(1, Number(estimatedPomodoros));

    const newItem = {
      id: Date.now(),                    // unique ID
      text: trimmedTask,
      priority: taskPriority,
      estimatedPomodoros: pomodoros,
      usedPomodoros: 0,                 // ✅ track progress
      category: taskCategory,
      completed: false,
    };

    setTasks((prev) => [...prev, newItem]);

    // Reset input fields
    setNewTask('');
    setTaskPriority('Normal');
    setEstimatedPomodoros(1);
    setTaskCategory('');
  }

  function toggleTaskCompletion(taskId) {
    setTasks((prev) =>
      prev.map((task) =>
        task.id === taskId
          ? { ...task, completed: !task.completed }
          : task
      )
    );
  }

  return {
    tasks,
    setTasks,
    newTask,
    setNewTask,
    taskPriority,
    setTaskPriority,
    estimatedPomodoros,
    setEstimatedPomodoros,
    taskCategory,
    setTaskCategory,
    addTask,
    toggleTaskCompletion,
  };
}
